import { type AnchorHTMLAttributes, memo, type ReactElement, type ReactNode } from "react";
import { cn } from "src/utilities/shadcnUtils";

const STYLES = {
  link: "w-fit inline text-gray-700 visited:text-gray-700 visited:hover:text-green-500 hover:text-green-500",
  underlined: "underline",
  notUnderlined: "no-underline",
};

export interface TextLinkProps extends Omit<AnchorHTMLAttributes<any>, "style"> {
  className?: string;
  children: string | ReactElement<any> | Array<string | ReactElement<any>> | ReactNode;
  underlined?: boolean;
}

const TextLink = ({ className, children, underlined, ...props }: TextLinkProps) => (
  <a
    target="_blank"
    className={cn(STYLES.link, underlined ? STYLES.underlined : STYLES.notUnderlined, className)}
    {...props}
  >
    {children}
  </a>
);

export default memo(TextLink);
